import { LoadState } from "../../constants/enums";
import {
	ICompanyOutletAttachment,
	ICompanyOutletAttachmentState,
} from "./companyOutletAttachment.types";

export const defaultCompanyOutletAttachment: ICompanyOutletAttachment = {
	company_outlet_attachment_uuid: null,
	company_outlet_attachment_name: "",
	company_outlet_uuid: "",
	company_outlet_name: "",
	is_vendor: "NO",
	link: "",
	status: "ACTIVE",
};
export const defaultCompanyOutletAttachmentState: ICompanyOutletAttachmentState =
	{
		list: {
			data: [],
			totalRecords: 0,
			loading: LoadState.NotLoaded,
			error: null,
		},
		attachemnt: {
			data: defaultCompanyOutletAttachment,
			loading: LoadState.NotLoaded,
			error: null,
		},
	};
